import { useTranslation } from 'react-i18next';

import { Modal, Spinner } from '@treams/treams-ui';

export default function FeedbackRequestModalLoading(props: { returnURL: string }) {
	const { t } = useTranslation();

	return (
		<Modal>
			<Modal.Header title={t('common.feedback.create')} />
			<Modal.Contents>
				<Spinner centered />
			</Modal.Contents>
		</Modal>
	);
}
